var map = {
	"./Agriculture.svg": "326d",
	"./Assembly.svg": "b341",
	"./Automotive.svg": "c90a",
	"./Cleaning.svg": "ab2c",
	"./Construction.svg": "3873",
	"./Cooking.svg": "f3d7",
	"./Delivery.svg": "de25",
	"./Demolition.svg": "9c48",
	"./Electrical.svg": "3601",
	"./Electronics.svg": "334b",
	"./Handyman.svg": "1234",
	"./Heavy Lifting.svg": "1171",
	"./Junk Removal.svg": "88f3",
	"./Landscaping.svg": "9d10",
	"./Machining.svg": "fb84",
	"./Moving.svg": "30af",
	"./Organization.svg": "841b",
	"./Other.svg": "c970",
	"./Painting.svg": "2b2a",
	"./Pet Care.svg": "3091",
	"./Plumbing.svg": "ad81",
	"./Tutoring.svg": "794c",
	"./Welding.svg": "e596"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0439";